import type { BranchKey } from '@festina-life/api'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { useNavigate } from 'react-router'

import { server as serverPath } from '../../../../system/paths'
import { useNavigationParams } from '../../../../system/useNavigationParams'
import { isEqualBranch } from '../../../../uiModels/branches/helpers'
type Props = {
  branchKey: BranchKey
}

export const CloseBranchButton = ({ branchKey }: Props) => {
  const translate = useTranslate()
  const navigate = useNavigate()
  const { block, layer, branch, server } = useNavigationParams()
  const currentBranchKey = branch ? { name: branch, server } : undefined
  const isCurrentBranch = isEqualBranch(branchKey, currentBranchKey)

  const handleCloseBranch = async () => {
    await navigate(serverPath({ server, block, layer, branch: undefined }))
  }

  return (
    <Button
      startIcon="XCircle"
      onClick={handleCloseBranch}
      disabled={!isCurrentBranch}
    >
      {translate('branchDetailsPanel.tabs.manage.closeBranch')}
    </Button>
  )
}
